// flights_unified_price_tag

import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";

const utils = createMicroConversionTrackingUtils({
  name: "flights_unified_price_tag",
  stages: {
    main: 1,
    ddot: 2,
    mdot: 3,
    withPriceBreakdownTooltip: 4,
    withPriceStrikethrough: 5,
    withPricePerAdultExplanation: 6,
    withPriceExplanation: 7,
    withPriceExplanationOnly: 8,
    withUsOutboundInbound: 9
  },
  defaultStage: 1,
  mainStage: 1,
  goals: {
    tooltipClick: 1
  },
  goalsWithValue: []
});

export const useTrackUnifiedPriceTag = () => {
  const { isDesktop, isMobile } = useProfiler();

  const trackUnifiedPriceTag = useCallback(() => {
    return !!utils.trackWithDefaultStage();
  }, []);

  const trackUnifiedPriceTagStages = useCallback(
    ({
      withPriceBreakdownTooltip = false,
      withPriceStrikethrough = false,
      withPricePerAdultExplanation = false,
      withPriceExplanation = false,
      withPriceExplanationOnly = false,
      withUsOutboundInbound = false
    }: {
      withPriceBreakdownTooltip?: boolean;
      withPriceStrikethrough?: boolean;
      withPricePerAdultExplanation?: boolean;
      withPriceExplanation?: boolean;
      withPriceExplanationOnly?: boolean;
      withUsOutboundInbound?: boolean;
    }) => {
      utils.stages.main();
      if (isDesktop()) utils.stages.ddot();
      if (isMobile()) utils.stages.mdot();
      if (withPriceBreakdownTooltip) utils.stages.withPriceBreakdownTooltip();
      if (withPriceStrikethrough) utils.stages.withPriceStrikethrough();
      if (withPricePerAdultExplanation) utils.stages.withPricePerAdultExplanation();
      if (withPriceExplanation) utils.stages.withPriceExplanation();
      if (withPriceExplanationOnly) utils.stages.withPriceExplanationOnly();
      if (withUsOutboundInbound) utils.stages.withUsOutboundInbound();
    },
    [isDesktop, isMobile]
  );

  return {
    trackUnifiedPriceTag,
    trackUnifiedPriceTagStages,
    trackUnifiedPriceTagGoals: utils.goals
  };
};
